export default __webpack_public_path__ + "static/media/img_papaground04.dc31c2e0.jpg";